
export class BaseClass {

    protected trim(value: string): string {
        return value ? value.trim() : '';
    }

    protected some(props: string[], value: string): boolean {
        return props.some(prop => prop.toLowerCase().includes(value));
    }
}
